import { render, staticRenderFns } from "./xuanzhuan.vue?vue&type=template&id=3ef049ae&"
import script from "./xuanzhuan.vue?vue&type=script&lang=js&"
export * from "./xuanzhuan.vue?vue&type=script&lang=js&"
import style0 from "./xuanzhuan.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports